import api from "./api";

export default class RoomApi {
  static async Get() {
    return await api.get(`room`);
  }
}
